
import { useContext, useEffect, useState, useRef } from 'react'
import { createRoot } from 'react-dom/client';
import axios from 'axios'
import Modal from 'react-modal'
import { useForm } from 'react-hook-form'
import moment from 'moment'
import { projectContext, loadingContext, urlValue, unfolder, closeModalVw, openModalVw, groupBy } from '../../lib'
// import AsideBar from './AsideBar'

import '../../styles/settings.scss'
import '../../styles/swicthcss.css'
import { customModal } from '../../styles/customModal'
import SideBar from '../../components/SideBar'
import TitleBar from '../../components/TitleBar'
import { useNavigate } from 'react-router-dom'
import ModalVw, { ModalBody, ModalContent, ModalHeader } from '../../components/common/ModalVw'
import Report from '../Report'
import ListReport from './ListReports'
import ReportCall from './ReportCall'
import * as XLSX from 'xlsx';
import ReactDOM from 'react-dom';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import CallReportResumePDF from './CallReportResumePDF';

export default function GeneralReports() {
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [project, setProject] = useState(null)
  const [clients, setClients] = useState([])
  const [modalRep, setModalRep] = useState(false)
  const [modalCallRep, setModalCallRep] = useState(false)
  const [call, setCall] = useState(null)
  const [pagination, setPagination] = useState({ total_page: 0, page: 1, count: 0, limit: 100 })
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState({
    delete: false,
    new: false,
    edit: false,
  })
  const [refresh, setRefresh] = useState(false)
  const [selectedClient, setSelectedClient] = useState()
  const ref = useRef(null)
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useContext(loadingContext)
  const [openTab, setOpenTab] = useState(1);
  const [call_list, setCallList] = useState([])
  const [call_list_excel, setCallListExcel] = useState([])
  const [campaings, setCampaings] = useState([])
  const [subCampaings, setSubCampaings] = useState([])
  const campaingRef = useRef('')
  const subCampaingRef = useRef('')
  const search_ref = useRef(null);
  const search_user = useRef(null);
  const from = useRef();
  const to = useRef();

  const [firstReport, setFirstReport] = useState('')
  const [secondReport, setSecondReport] = useState('')
  const [thirdReport, setThirdReport] = useState('')
  const [forthReport, setForthReport] = useState('')
  const [fifthReport, setFifthReport] = useState('')
  const [sixthReport, setSixthReport] = useState('')
  const [seventhReport, setSeventhReport] = useState('')
  const tableRef = useRef(null);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm()

  useEffect(() => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    setLoading(true)

    axios({
      method: 'get',
      url: `${urlValue}/studio/agent`,
      headers: {
        'access-token': token,
      },
    })
      .then(function (response) {
        setClients(response.data)
        setLoading(false)
      })
      .catch(function (error) {
        setLoading(false)
      })
  }, [refresh])

  const obtenerFechaActual = (firstday) => {
    const hoy = new Date();
    const año = hoy.getFullYear();
    let mes = hoy.getMonth() + 1;
    if (mes < 10) {
      mes = '0' + mes;
    }
    let dia = hoy.getDate();
    if (dia < 10) {
      dia = '0' + dia;
    }
    if (firstday){
      dia = '01'
    }
    return `${año}-${mes}-${dia}`;
  }

  const fetchCampaing = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/project/camp/campaing`;
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });

      if (rest.status === 200 && rest.data) {
        setCampaings(rest.data.data)
      }
      return rest;;
    } catch (error) {
      console.log(error)
      return error;
    }
  }

  const fetchSubCampaing = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/project/camp/sub-campaing`;
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });

      if (rest.status === 200 && rest.data) {
        setSubCampaings(rest.data.data)
      }
      return rest;
    } catch (error) {
      console.log(error)
      return error;
    }
  }


  const searchCall = async (search, page, mas, exportExcel = false) => {

    try {
      let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
      let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
      // setLoading(true)
      
      const res = await axios.post(
        `${urlValue}/studio/project/reports/call`,
        { search, 
          pagination: page,
          user_id: id,
          initialDate: moment(from.current.value).format('YYYY-MM-DD') + ' 00:00:00',
          finishDate: moment(to.current.value).format('YYYY-MM-DD') + ' 23:59:59',
          userSearch: search_user.current.value,
          campaign: campaingRef.current.value === 'All' ? '' : campaingRef.current.value,
          sub_campaign: subCampaingRef.current.value === 'All' ? '' : subCampaingRef.current.value
        },
        {
          headers: {
            'access-token': token,
            user: id
          },
        })

      if (res.status === 200) {
        if (mas) {
          setCallList((prev) => prev.concat(res.data?.data))
        } 
        else if (exportExcel) {
          setCallListExcel(res.data?.data)
        }
        else {
          setCallList(res.data?.data)
        }
        setPagination({ ...pagination, page: page.page, total_page: res.data.total_page, count: res.data.count })

        // setLoading(false)
      }
    } catch (error) {

    }

  }

  useEffect(() => {
    from.current.value = obtenerFechaActual(true)
    to.current.value = obtenerFechaActual(false)
    fetchCampaing()
    fetchSubCampaing()
    searchCall("", { ...pagination, page: 1 }, false);
  }, [])

  const [projects, setProjects] = useState([])
  const fecthProjects = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;

    axios({
      method: 'get',
      // url: 'http://localhost:8080/studio/project',
      url: `${urlValue}/studio/client/projects-user/${id}`,
      // url: `${urlValue}/studio/project/category/outbound`,
      headers: {
        'access-token': token,
        user: id
      },
    })
      .then(function (response) {

        // setAnswers(response.data)
        getProjects(response.data);
        //setLoading(false);
      })
      .catch(function (error) {
        console.log(error)
        setLoading(false)
      })
  }
  useEffect(() => {
    // fecthProjects();
  }, [])

  const getProjects = async asignedProjects => {
    // setSelectedProject(selectedProject)
    setProjects([])
    setLoading(true)
    let proj = [];
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
    for (var i = 0; i < asignedProjects.length; i++) {
      const url = `${urlValue}/studio/project/${asignedProjects[i].project}`;
      const res = await axios({
        method: 'get',
        url: url,
        // url: `${urlValue}/studio/project/category/inbound`,
        headers: { 'access-token': token, user: id }
      });
      
      proj.push(res.data);
    }
    setProjects(proj);
    setLoading(false)
  }


  const postClientProject = clientId => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    axios({
      method: 'post',
      url: `${urlValue}/studio/client-project`,
      headers: {
        'access-token': token,
      },
      data: {
        project_id: selectedProject.id,
        client_id: clientId,
      },
    })
      .then(function (response) {
        setIsModalOpen({ ...isModalOpen, new: false })
        setLoading(false)
        setRefresh(!refresh)
      })
      .catch(function (error) {
        setIsModalOpen({ ...isModalOpen, new: false })
        setLoading(false)
      })
  }

  const getIdClientByCcmsId = async ccmsId => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    return await axios({
      method: 'get',
      url: `${urlValue}/studio/client`,
      headers: {
        'access-token': token,
      },
    })
      .then(function (response) {
        setLoading(false)
        return response.data.filter(value => {
          if (value.ccms_id == ccmsId) {
            return value
          }
        })[0].id
      })
      .catch(function (error) {
        setLoading(false)
      })
  }


  const openModalRep = (p) => {
    setProject(p)
    openModalVw("#repgeneral-modal", () => setModalRep(true))
  }
  const openModalCallRep = (data) => {
    setCall(data)
    setTimeout(() => {
      openModalVw("#reportcall-modal", () => setModalCallRep(true))
    }, 500)
  }

  const onSearchProject = (value) => {
    console.log("Project")
    searchCall(value, { ...pagination, page: 1 }, false);
  }

  const onChangeSelect = () => {
    console.log("Campaign", search_ref.current.value)
    searchCall(search_ref.current.value, { ...pagination, page: 1 }, false);
  }

  const onChange = () => {
    console.log("Date")
    searchCall(search_ref.current.value,  { ...pagination, page: 1 }, false );
  }

  const onSearchUser = () => {
    console.log("User")
    searchCall(search_ref.current.value,  { ...pagination, page: 1 }, false );
  }


  const handleScroll = (e) => {

    if (e) {
      const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;

      // Verificar si el scroll ha llegado al final
      if ((scrollTop + clientHeight) + 5 >= scrollHeight) {
        let search = search_ref.current.value;
        
        let page = { ...pagination, page: (pagination.page += 1) }
        searchCall(search, page, true)
      } else {
        // console.log("no")
      }
      // setIsScrolledToBottom(scrollTop + clientHeight >= scrollHeight);
    }
  };

  useEffect(() => {
    const element = document.querySelector('#panel-infinity');
    if (element) {
      element.addEventListener('scroll', handleScroll);

      return () => {
        element.removeEventListener('scroll', handleScroll);
      };
    }
  }, [])

  useEffect(() => { 
    let dataExpor = [{}]

    if (call_list_excel.length > 0) {
      for (let i = 0; i < call_list_excel.length; i++) {
        const data = { 
          id: call_list_excel[i].id,
          user: call_list_excel[i].bussiness_key,
          project_name: call_list_excel[i].project_name,
          date: call_list_excel[i].created_date,
          duration_call: call_list_excel[i].time_call,
          score: ((call_list_excel[i]?.evaluations?.qualification * 100) || 0).toFixed(1),
          num_time_hold: call_list_excel[i].AmountTimeHold,
          time_hold_second: call_list_excel[i].TimeSecondHold,
          evaluations: call_list_excel[i].evaluations
        }
        dataExpor.push(data)
      }
  
      const wb = XLSX.utils.book_new();
      // Convertir el array a una hoja de cálculo
      const ws = XLSX.utils.json_to_sheet(dataExpor);
      // Agregar la hoja de cálculo al libro de Excel
      XLSX.utils.book_append_sheet(wb, ws, 'Datos');
      
      // Escribir el libro de Excel a un archivo
      XLSX.writeFile(wb, 'projects_reports.xlsx');
    }
    
  }, [call_list_excel])

  const exportToExcelN = async ( filename = 'export.xlsx', sheetName = 'Sheet1') => {
    await searchCall("",  { total_page: 0, page: 1, count: 0, limit: 1000 }, false, true);
  }

  const downloadReportPDF = async (data) => {
    const container = document.createElement('div');
    document.body.appendChild(container);
  
    const root = createRoot(container);
  
    let isLoading = true;
  
    const onLoadComplete = () => {
      isLoading = false;
    };
  
    root.render(<CallReportResumePDF data={data} onLoadComplete={onLoadComplete} />);
  
    // Función para esperar hasta que el contenido esté cargado
    const waitForLoad = async () => {
      while (isLoading) {
        await new Promise(resolve => setTimeout(resolve, 100)); // Verifica cada 100 ms
      }
    };
  
    // Promesa que se resuelve si se carga el contenido
    const loadPromise = waitForLoad();
  
    // Promesa que se rechaza si pasa más de 10 segundos
    const timeoutPromise = new Promise((_, reject) => 
      setTimeout(() => reject(new Error('PDF generation timed out')), 10000) // 10 segundos
    );
  
    try {
      await Promise.race([loadPromise, timeoutPromise]);
  
      // Si pasa la espera, generamos el PDF
      html2canvas(container).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        const imgWidth = 210; // A4 width in mm
        const pageHeight = 295; // A4 height in mm
        const imgHeight = canvas.height * imgWidth / canvas.width;
        let heightLeft = imgHeight;
        let position = 0;
  
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
  
        while (heightLeft >= 0) {
          position -= pageHeight;
          pdf.addPage();
          pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }
  
        pdf.save('call_report.pdf');
  
        root.unmount();
        document.body.removeChild(container);
      });
  
    } catch (error) {
      if (error.message === 'PDF generation timed out') {
        alert('No se ha podido generar el PDF, intente de nuevo');
      }
      root.unmount();
      document.body.removeChild(container);
    }
  };

  return (
    <>
      <div>

        <section className="container-answers general-container" id="container">
          <div className="row_primary">
            <div className="con_title_bar">
              <TitleBar />
            </div>
            <div className="con_header">
              <div className="header">
                <div className="title">
                  <div className="intents">
                    <div className="project-name-container">
                      <div className="icon"></div>
                    </div>
                    <div>
                      <h1 style={{ color: "#0087ff", fontWeight: "bold" }}>Reports</h1>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex" style={{backgroundColor: '#F7F7F7', marginTop: 15, padding: 20, flexDirection: 'row', justifyContent: 'space-around', 
                borderRadius: '25px 25px 0 0', alignItems: 'center'}}>
                
                <div className="home-search ml-0 bg-white d-flex flex-row align-items-center justify-space-between"
                  style={{ backgroundColor: '#F7F7F7', width: 200, height: 30 }}>
                  <div className='mr-2 label-report'>Campaign: </div>
                  <div className="select" style={{ flexGrow: '2' }}>
                    <select id="campaign" ref={campaingRef} className='select-nesting select-report'
                      style={{ flexGrow: '2', fontSize: 12, backgroundPositionX: "98%" }}
                      onChange={onChangeSelect}>
                      <option key={9999} value={"All"}>All</option>
                      {campaings.map((item, i) => (
                        <option key={i} value={item.name}  >{item.name}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="home-search ml-3 bg-white d-flex flex-row align-items-center justify-space-between"
                  style={{ backgroundColor: '#F7F7F7', width: 200, height: 30 }}>
                  <div className='mr-2 label-report'>Sub Campaign: </div>
                  <div className="select" style={{ flexGrow: '2' }}>
                    <select id="campaign" ref={subCampaingRef} className='select-nesting select-report'
                      style={{ flexGrow: '2', fontSize: 12, backgroundPositionX: "98%" }}
                      onChange={onChangeSelect}>
                      <option key={9999} value={"All"}>All</option>
                      {subCampaings.map((item, i) => (
                        <option key={i} value={item.name} >{item.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
                
                <div className="home-search ml-3 bg-white d-flex flex-row align-items-center justify-space-between"
                  style={{ borderRadius: 20, backgroundColor: 'white', width: 200, border: '1px solid #4D4D4D', height: 30 }}>
                                   
                  <input
                    type="text"
                    ref={search_ref}
                    placeholder="Search Project"
                    onChange={event => {
                      onSearchProject(event.target.value)
                    }}
                    className="p-2 home-search"
                    style={{ border: 'none', marginLeft: 7, maxWidth: 160, borderRadius: '20px' }}
                  />
                  <div className="p-1 pr-5 mt-1">
                    <img src="/icons/search.svg" style={{ width: 16, minWidth: 16, marginLeft: -8 }} alt='' />
                  </div>
                </div>

                <div className="home-search ml-3 bg-white d-flex flex-row align-items-center justify-space-between"
                  style={{ borderRadius: 20, backgroundColor: 'white', width: 200, border: '1px solid #4D4D4D', height: 30 }}>
                  <input
                    ttype="text"
                    placeholder="Search user"
                    ref={search_user}
                    onChange={onSearchUser}
                    className="p-2 home-search"
                    style={{ border: 'none', marginLeft: 7, maxWidth: 160, borderRadius: '20px' }}
                  />
                  <div className="p-1 pr-5 mt-1">
                    <img src="/icons/search.svg" style={{ width: 16, minWidth: 16, marginLeft: -8 }} alt='' />
                  </div>
                </div>

                <div className='  flex flex-row items-center'>
                  <div className='mr-2 label-report'>From: </div>
                  <input id="from" ref={from} onChange={onChange} type='date'
                    className="input-nesting input-date  input-date-nesting" />
                </div>
                <div className='  flex flex-row items-center'>
                  <div className='mr-2 label-report'>To: </div>
                  <input ref={to} onChange={onChange} type='date' className="input-nesting input-date  input-date-nesting" />
                </div>
                {/* <button className='button-setup setup-btn' style={{ marginLeft: "20px", height: 30 }} type='button' onClick={() => { exportToExcelN( 'table-report', 'excel-data') }}>Exportar a Excel</button> */}
                <button className='button-setup setup-btn' style={{ marginLeft: "20px" }} type='button' onClick={() => { exportToExcelN( 'table-report', 'excel-data') }}>Export</button>
              </div>
              <div className='w-full flex flex-row details-project' style={{backgroundColor: '#F7F7F7'}}>
                  <div id='panel-infinity' className="body w-full content-infinity">
                    
                    <ListReport
                      id="table-report"
                      openReport={openModalRep}
                      openCallReport={openModalCallRep}
                      downloadPDF={downloadReportPDF}
                      listCall={call_list}
                      search={search}
                    />
                </div>
              </div>
            </div>
          </div>
        </section>

        {modalRep ?
          <ModalVw clases="bg-[#00000061]" id="repgeneral-modal" visible={modalRep}  >
            <ModalContent styles={{ height: "92%", width: '80%' }} clases={`bg- sm:w-[80%] md:w-[80%] lg:w-[70%] xl:w-[80%] 2xl:w-1/3  w-[80%]  sm:h-[80%] md:h-[80%] lg:h-[80%] xl:h-[80%]  h-[92%] bg-white`}>
              <ModalHeader title="" onClose={() => closeModalVw("#repgeneral-modal", () => setModalRep(false))} />
              <ModalBody clases={`w-full`} >
                <Report project={project} onClose={() => closeModalVw("#repgeneral-modal", () => setModalRep(false))} />
              </ModalBody>
            </ModalContent>
          </ModalVw> : null}


        {modalCallRep ?
          <ModalVw style={{ backgroundColor: '#00000061' }} className="bg-[#00000061]" id="reportcall-modal" visible={modalCallRep}  >
            <ModalContent styles={{ overflow: 'hidden', width: '85%' }} clases={` cont-report-md sm:w-[80%] md:w-[80%] lg:w-[70%] xl:w-[55%] 2xl:w-1/3  w-[27%]  sm:h-[90%] md:h-[90%] lg:h-[90%] xl:h-[95%]  h-[92%]  `}>
              <ModalHeader title="" onClose={() => closeModalVw("#reportcall-modal", () => setModalCallRep(false))} />
              <ModalBody clases={``} styles={{ width: "98%", }} >
                <ReportCall data={call} onClose={() => closeModalVw("#reportcall-modal", () => setModalCallRep(false))} />
              </ModalBody>
            </ModalContent>
          </ModalVw> : null}
      </div>
    </>
  )
}
